export default "__VITE_ASSET__d187c052__"